// extracted by css-extract-rspack-plugin
export default {"ColorButton":"NotebookActionButton-module__ColorButton___pF2hZ","secondary":"NotebookActionButton-module__secondary___VSvim"};